import Grid from "@material-ui/core/Grid";
import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ContactsUpload from "../../components/contacts/ContactsUpload";
import { MobileContext } from "../Mobile";

const useStyles = makeStyles(theme => ({
  overflowHidden: {
    overflow: "hidden"
  }
}));

const Upload = () => {
  const { onDrawerOpen } = useContext(MobileContext);
  const classes = useStyles();

  return (
    <Grid container spacing={0} className={classes.overflowHidden}>
      <Grid item xs={12}>
        <ContactsUpload mobile onDrawerOpen={onDrawerOpen} />
      </Grid>
    </Grid>
  );
};

export default Upload;
